import React from 'react';
import { PublicPlan } from '@wix/ambassador-pricing-plans-v2-plan/types';
import { Plan } from '@wix/ambassador-pricing-plans-v3-plan/types';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { getRecurrenceText } from '../../../../../utils/plan-unified-utils';
import { st, classes } from './Recurrence.st.css';

export interface RecurrenceProps {
  plan: PublicPlan | Plan;
  recurringPlansExist: boolean;
  highlighted: boolean;
}

export const Recurrence: React.FC<RecurrenceProps> = ({ plan, recurringPlansExist, highlighted }) => {
  const { t } = useTranslation();

  if (!recurringPlansExist) {
    return null;
  }

  return (
    <span data-hook={VIEWER_HOOKS.PLAN_RECURRENCE} className={st(classes.frequency, { highlighted })}>
      {getRecurrenceText(plan, t)}
    </span>
  );
};
